import _					from "lodash";
import { Auth } 			from "./Auth";
import sha1 				from "sha1";

import { Server } 			from "./Server";
import Service				from "./../../Libs/Service";
import SetupSettings 		from "./../settings/settings.json";

import { Settings } 		from './Settings';
import { Version } 			from './Version';
import { Monitoring } 		from "./Monitoring";
import { Notifications } 	from "./Notifications";

import { AssetGeneration }	from "./Asset.Generation";
import { AssetUpload }		from "./Asset.Upload";
import { AssetDimension }	from "./Asset.Dimension";
import { AssetFrameDrop }	from "./Asset.FrameDrop";

let Asset = new Service({

	Name: "Asset",

	Libraries: [AssetGeneration, AssetUpload, AssetDimension, AssetFrameDrop],

	Events: {

		//Переключение рабочей ноды: активные карты данных подменяются картами этой ноды
		"Cluster Working Node Changed": function(previousServerId, serverId) {

			this.useServer(serverId);

		},

		"Selected Version Switched, Selected Creative Compression Data Loaded, Selected Creative Compression Data Changed, Selected Version Asset Added, Selected Version Assets Changed,Selected Version Assets Restored,Selected Version Assets Deleted,Active Processes Changed:asset-compress": function () {

			if (!Version.SelectedVersion) return;

			this.selectedVersionAssets = this.getVersionAssets(Version.SelectedVersion);

			_.forEach(this.selectedVersionAssets, (value, key) => {

				if (value.cacheKey) {

					this.selectedVersionAssets[key].compressionData = this.CompressionCacheData[Version.SelectedVersion['creative_id']][value.cacheKey];

				}

			});

			this.selectedVersionAssetsByType = _.groupBy(this.selectedVersionAssets, "type");

			this.selectedVersionAssetCompressionData = {};

			_.keys(this.selectedVersionAssetsByType).forEach(type => {

				let size = 0;
				let isError = false;
				let isProcessing = false;
				let isUnknown = false;

				let codenames = _.map(_.values(_.filter(this.selectedVersionAssetsByType[type], asset => asset.type !== 'image' || !asset.options.atlases || asset.options.atlases.length === 0)), 'codename');

				size = this.getSize(codenames);
				isProcessing = this.getProcessing(codenames);
				isUnknown = this.getUnknown(codenames);
				isError = this.getError(codenames);

				this.selectedVersionAssetCompressionData[type] = {
					size: size,
					isError: isError,
					isProcessing: isProcessing,
					isUnknown: isUnknown
				}

			});

			Broadcast.call("Asset Compression Data Changed");

		}

	},

	Actions: {

		//serverId - нода, с которой пришли данные
		"Assets": function(assetsByVersions, data, size, serverId) {

			_.each(assetsByVersions, (versionAssets, versionId) => {

				_.each(versionAssets, (newAsset, assetCodename) => {

					this.setAsset(parseInt(versionId), assetCodename, newAsset, serverId);

				});

				// Если установлен этот маркер - значит отправляются все ассеты указанной версии (создание новой версии)
				if (data.AssetsVersionId) {

					Broadcast.call(`Version Assets Loaded`, [versionId]);

				}

			});

			// Если установлен этот маркер - значит это первоначальное получение данных о только что впервые открытом креативе (все ассеты всех версий креатива загружаются)
			if (data.AssetsCreativeId) Broadcast.call(`Creative Assets Loaded`, [data.AssetsCreativeId]);
			if (data.AssetsVersionId) Broadcast.call(`Version Assets Loaded`, [data.AssetsVersionId]);

			// Помечаем этим маркером первоначальную загрузку ассетов первого наблюдаемого креатива
			this.loaded = true;

		},

		"AssetsOriginal": function(assetsOriginalByVersions, data, size, serverId) {

			let assetsOriginalByVersion = this.getServerMap(this.AssetsOriginalByVersionByServer, serverId || this.NodeServerId),
				assetsOriginalByVersionByCodename = this.getServerMap(this.AssetsOriginalByVersionByCodenameByServer, serverId || this.NodeServerId);

			_.each(assetsOriginalByVersions, (versionAssetsOriginal, versionId) => {

				assetsOriginalByVersion[versionId] = {};
				assetsOriginalByVersionByCodename[versionId] = {};

				_.each(versionAssetsOriginal, (newAssetOriginal, assetCodename) => {

					this.setAssetOriginal(parseInt(versionId), assetCodename, newAssetOriginal, serverId);

				});

			});

			if (data.AssetsCreativeId) Broadcast.call(`Creative Assets Original Loaded`, [data.AssetsCreativeId]);
			if (data.AssetsVersionId) Broadcast.call(`Version Assets Original Loaded`, [data.AssetsVersionId]);

		},

		"ChangedAssetsData": function(changedAssetsData, data, size, serverId) {

			this.detectAssetsChanges(changedAssetsData, serverId);

		},

		"CompressionCacheSize": function(size) {

			this.CompressionCacheSize = size;

			Broadcast.call("Compression Cache Size Changed");

		},

		"CreativeCompressionCacheData": function(creativeCompressionData, data, size, serverId) {

			this.getServerMap(this.CompressionCacheDataByServer, serverId || this.NodeServerId)[data.CreativeId] = creativeCompressionData;

			if (Creative.SelectedCreative?.id === data.CreativeId) Broadcast.call("Selected Creative Compression Data Loaded");

		},

		"CompressionCacheData": function(compressionData, data, size, serverId) {

			let compressionCacheData = this.getServerMap(this.CompressionCacheDataByServer, serverId || this.NodeServerId);

			if (!compressionCacheData[data.CreativeId]) compressionCacheData[data.CreativeId] = {};
			compressionCacheData[data.CreativeId][data.CacheKey] = compressionData;

			if (Creative.SelectedCreative?.id === data.CreativeId) Broadcast.call("Selected Creative Compression Data Changed");

		}

	},

	init() {

		//Карты данных по нодам кластера: у каждой ноды своя БД, и id версий и ассетов
		//на разных нодах совпадают, поэтому карты разделены по нодам (Client/Libs/Service.js, getServerMap)
		this.AssetsByServer = {};
		this.AssetsByVersionByServer = {};
		this.AssetsByVersionByCodenameByServer = {};

		this.AssetsOriginalByServer = {};
		this.AssetsOriginalByVersionByServer = {};
		this.AssetsOriginalByVersionByCodenameByServer = {};

		this.CompressionCacheDataByServer = {};
		this.AssetUploadsByServer = {};
		this.AssetUploadsByHierarchyByServer = {};
		this.DimensionsByServer = {};
		this.DimensionsByHierarchyByServer = {};
		this.GenerationsByServer = {};
		this.GenerationsByHierarchyByServer = {};

		this.loaded = false;

		this.atlasesColors = ['#4dbd74', '#e83e8c', '#ffc107', '#6f42c1', '#f86c6b', '#20a8d8', '#20c997'];

		this.audioInstances = {};

		// Скин и анимация Spine ассетов, выбранные пользователем в свойствах ассета ("versionId-codename" -> {skin, animation}).
		// Хранится только в памяти до перезагрузки страницы - по ним проигрывается превью Spine при наведении
		this.SpineSelections = {};

		this.CompressionCacheSize = 0;

		// Активные карты - карты рабочей ноды
		this.useServer(0);

		window.addEventListener("message", e => {

			if (e.data?.setAssetsEnabledFromGame) this.setAssetsEnabled(e.data.setAssetsEnabledFromGame.assets);

		});

	},

	// Активные карты данных рабочей ноды: при переключении ноды они подменяются ссылками на карты
	// этой ноды, поэтому код обращения к ним (Assets[id], AssetsByVersion[versionId]) не меняется
	useServer(serverId) {

		serverId = serverId || 0;

		if (this.NodeServerId === serverId) return;

		this.NodeServerId = serverId;

		this.Assets = this.getServerMap(this.AssetsByServer, serverId);
		this.AssetsByVersion = this.getServerMap(this.AssetsByVersionByServer, serverId);
		this.AssetsByVersionByCodename = this.getServerMap(this.AssetsByVersionByCodenameByServer, serverId);

		this.AssetsOriginal = this.getServerMap(this.AssetsOriginalByServer, serverId);
		this.AssetsOriginalByVersion = this.getServerMap(this.AssetsOriginalByVersionByServer, serverId);
		this.AssetsOriginalByVersionByCodename = this.getServerMap(this.AssetsOriginalByVersionByCodenameByServer, serverId);

		this.CompressionCacheData = this.getServerMap(this.CompressionCacheDataByServer, serverId);
		this.AssetUploads = this.getServerMap(this.AssetUploadsByServer, serverId);
		this.AssetUploadsByHierarchy = this.getServerMap(this.AssetUploadsByHierarchyByServer, serverId);
		this.Dimensions = this.getServerMap(this.DimensionsByServer, serverId);
		this.DimensionsByHierarchy = this.getServerMap(this.DimensionsByHierarchyByServer, serverId);
		this.Generations = this.getServerMap(this.GenerationsByServer, serverId);
		this.GenerationsByHierarchy = this.getServerMap(this.GenerationsByHierarchyByServer, serverId);

	},

	setAssetsEnabled(assets) {

		if (!Version || !Version.SelectedVersion) return;

		const versionId = Version.SelectedVersion.id;

		Server.sendToSocket({
			SetAssetsEnabled: {
				versionId,
				assets
			}
		});

	},

	resetAsset(assetCodename) {
		if(!Version || !Version.SelectedVersion) return;

		const versionId = Version.SelectedVersion.id;

		Server.sendToSocket({
			ResetAsset: {
				versionId,
				assetCodename
			}
		});
	},

	// serverId - нода, с которой пришли данные: пишем в карты этой ноды
	setAssetOriginal(versionId, assetCodename, assetOriginal, serverId) {

		serverId = serverId || this.NodeServerId;

		let assetsOriginal = this.getServerMap(this.AssetsOriginalByServer, serverId),
			assetsOriginalByVersion = this.getServerMap(this.AssetsOriginalByVersionByServer, serverId),
			assetsOriginalByVersionByCodename = this.getServerMap(this.AssetsOriginalByVersionByCodenameByServer, serverId);

		assetsOriginal[assetOriginal.id] = assetOriginal;

		if (!assetsOriginalByVersion[assetOriginal['version_id']]) assetsOriginalByVersion[assetOriginal['version_id']] = {};
		assetsOriginalByVersion[assetOriginal['version_id']][assetOriginal.id] = assetOriginal;

		if (!assetsOriginalByVersionByCodename[assetOriginal['version_id']]) assetsOriginalByVersionByCodename[assetOriginal['version_id']] = {};
		assetsOriginalByVersionByCodename[assetOriginal['version_id']][assetOriginal.codename] = assetOriginal;

	},

	setAsset(versionId, assetCodename, asset, serverId) {

		serverId = serverId || this.NodeServerId;

		let assets = this.getServerMap(this.AssetsByServer, serverId),
			assetsByVersion = this.getServerMap(this.AssetsByVersionByServer, serverId),
			assetsByVersionByCodename = this.getServerMap(this.AssetsByVersionByCodenameByServer, serverId);

		let oldAsset = assetsByVersionByCodename[versionId]?.[assetCodename];

		if (asset) {

			assets[asset.id] = asset;

			if (!assetsByVersion[asset['version_id']]) assetsByVersion[asset['version_id']] = {};
			assetsByVersion[asset['version_id']][asset.id] = asset;

			if (!assetsByVersionByCodename[asset['version_id']]) assetsByVersionByCodename[asset['version_id']] = {};
			assetsByVersionByCodename[asset['version_id']][asset.codename] = asset;

		} else {

			if (oldAsset) {

				delete assets[oldAsset.id];
				if (assetsByVersion[oldAsset['version_id']]) delete assetsByVersion[oldAsset['version_id']][oldAsset.id];
				if (assetsByVersionByCodename[oldAsset['version_id']]) delete assetsByVersionByCodename[oldAsset['version_id']][oldAsset.codename];

			}

		}

	},

	// Определяем какие конкретно изменения произошли (serverId - нода, с которой пришли данные)
	detectAssetsChanges(changedAssetsData, serverId) {

		serverId = serverId || this.NodeServerId;

		let assetsByVersionByCodename = this.getServerMap(this.AssetsByVersionByCodenameByServer, serverId),
			assetsOriginalByVersionByCodename = this.getServerMap(this.AssetsOriginalByVersionByCodenameByServer, serverId);

		// console.log('detectAssetsChanges 1', changedAssetsData);

		const SelectedVersionAssetsChanged = [];
		const AssetsChanged = [];

		const SelectedVersionAssetsRestored = [];
		const SelectedVersionAssetsDeleted = [];

		const AssetsRestored = [];
		const AssetsDeleted = [];

		_.each(changedAssetsData, changedAssetData => {

			const versionId = changedAssetData.versionId;
			const assetCodename = changedAssetData.assetCodename;
			const oldAsset = assetsByVersionByCodename[versionId]?.[assetCodename];
			const newAsset = changedAssetData.asset;

			// console.log('detectAssetsChanges oldAsset, newAsset', oldAsset, newAsset);

			this.setAsset(changedAssetData.versionId, changedAssetData.assetCodename, changedAssetData.asset, serverId);

			if (oldAsset) {

				if (newAsset) {

					if (newAsset.version_id === Version.SelectedVersion?.id) {

						SelectedVersionAssetsChanged.push([newAsset.version_id, newAsset.codename]);

					} else {

						AssetsChanged.push([newAsset.version_id, newAsset.codename]);

					}

				}

				// Если изменения ассета удалили (возможно нажали reset - в этом случае AssetsByVersionByCodename удаляется, остаётся только AssetsOriginalByVersionByCodename)
				else {

					// console.log('detectAssetsChanges oldAsset && !newAsset 1');

					// Если это ассет текущей просматриваемой пользователем версии креатива
					if (oldAsset.version_id === Version.SelectedVersion?.id) {

						// console.log('detectAssetsChanges oldAsset && !newAsset 2');

						// Если ассет был в json файле настроек
						if (assetsOriginalByVersionByCodename[Version.getVersion(oldAsset.version_id)?.baseVersionId]?.[oldAsset.codename]) {

							// console.log('detectAssetsChanges oldAsset && !newAsset 3');

							SelectedVersionAssetsRestored.push([oldAsset.version_id, oldAsset.codename]);

						} else {

							// console.log('detectAssetsChanges oldAsset && !newAsset 4');

							SelectedVersionAssetsDeleted.push([oldAsset.version_id, oldAsset.codename]);

						}

					} else {

						// Если ассет был в json файле настроек
						if (assetsOriginalByVersionByCodename[Version.getVersion(oldAsset.version_id)?.baseVersionId]?.[oldAsset.codename]) {

							AssetsRestored.push(oldAsset);

						} else {

							AssetsDeleted.push(oldAsset);

						}

					}

				}

			}

			// Если такого объекта изменений ассета ещё не было на клиенте
			else {

				// Если в новых пришедших данных есть объект изменённых данных ассета
				if (newAsset) {

					// Если это ассет текущей просматриваемой пользователем версии креатива
					if (newAsset.version_id === Version.SelectedVersion?.id) {

						SelectedVersionAssetsChanged.push([newAsset.version_id, newAsset.codename]);

					} else {

						AssetsChanged.push([newAsset.version_id, newAsset.codename]);

					}

				}

				// Если изменения ассета удалили (возможно reset)
				else {

					// Тут можно ничего не делать. Изменений ассета и так не было, но пришло сообщение что их удалили

					// Но есть нюанс: если заменили картинку в текстуре, то с сервера придет как сообщение об изменении спрайта,
					// так и сообщение об изменении текстуры. Однако в этих сообщениях передаются только изменённые данные ресурса.
					// В этом случае у спрайта они будут, а вот у текстуры не будет их - так как она сама не менялась.
					// В итоге и oldAsset будет null и newAsset будет null
					// Нужно здесь искусственно запустить событие об обновлении текстуры в этом случае

					let originalAsset = assetsOriginalByVersionByCodename[Version.getVersion(changedAssetData.versionId)?.baseVersionId]?.[changedAssetData.assetCodename];
					if (originalAsset?.type === "atlas") {

						SelectedVersionAssetsChanged.push([changedAssetData.versionId, changedAssetData.assetCodename]);

					}

				}

			}
		});

		// console.log('detectAssetsChanges 2', SelectedVersionAssetsChanged, AssetsChanged, SelectedVersionAssetsRestored, SelectedVersionAssetsDeleted, AssetsRestored, AssetsDeleted);

		if (SelectedVersionAssetsChanged.length) Broadcast.call("Selected Version Assets Changed", SelectedVersionAssetsChanged);
		if (AssetsChanged.length) Broadcast.call("Assets Changed", AssetsChanged);

		if (SelectedVersionAssetsRestored.length) Broadcast.call("Selected Version Assets Restored", SelectedVersionAssetsRestored);
		if (SelectedVersionAssetsDeleted.length) Broadcast.call("Selected Version Assets Deleted", SelectedVersionAssetsDeleted);

		if (AssetsRestored.length) Broadcast.call("Assets Restored", AssetsRestored);
		if (AssetsDeleted.length) Broadcast.call("Assets Deleted", AssetsDeleted);

	},

	getAsset(version, assetCodename, withCacheKey = true) {

		// Оригинальное значение из json файла настроек (его может не быть если ассет создан в дашборде)
		let assetOriginal = this.AssetsOriginalByVersionByCodename[version.baseVersionId || version.id]?.[assetCodename];
		// Изменённые данные или данные созданные в дашборде (их может не быть если ассет был сканирован из json файла и не менялся)
		let assetChanges = this.AssetsByVersionByCodename[version.id]?.[assetCodename];

		if (!assetOriginal && !assetChanges) return null;

		let asset = {};

		if (assetOriginal) {

			_.extend(asset, _.pickBy({'publisher_id': assetOriginal['publisher_id'], 'creative_id': assetOriginal['creative_id'], 'version_id': assetOriginal['version_id'], originalAssetId: assetOriginal['id'], codename: assetOriginal['codename'], title: assetOriginal['title'], type: assetOriginal['type'], url: assetOriginal['url'], Tags: _.clone(assetOriginal.Tags), timestamp: assetOriginal['timestamp'], options: _.cloneDeep(assetOriginal['options']), cacheKey: assetOriginal['cacheKey']}, v => !!v));

		}

		if (assetChanges) {

			_.extend(asset, _.pickBy({'publisher_id': assetChanges['publisher_id'], 'creative_id': assetChanges['creative_id'], 'version_id': assetChanges['version_id'], changedAssetId: assetChanges['id'], codename: assetChanges['codename'], title: assetChanges['title'], type: assetChanges['type'], url: assetChanges['url'], timestamp: assetChanges['timestamp'], cacheKey: assetChanges['cacheKey']}, v => !!v));

			if (assetChanges.Tags['enabled'] && asset.Tags) delete asset.Tags.disabled;

			asset.Tags = _.extend(asset.Tags || {}, assetChanges.Tags);
			asset.options = _.extend(asset.options || {}, assetChanges.options);

		}

		// Если у ассета нет изменений - берётся оригинальная запись с id базовой версией, но код рассчитывает на то, что в ассете всегда будет реальный version_id той версии к которой принадлежит ассет
		asset['version_id'] = version.id;

		asset.isRandom = this.isRandomAsset(asset);
		asset.isChanged = this.isChangedAsset(version, assetCodename);

		asset.timestamp = new Date(asset.timestamp);

		asset.isPNG = (asset.type === 'image' && _.endsWith(asset.url, '.png'));
		asset.isJPG = (asset.type === 'image' && _.endsWith(asset.url, '.jpg'));
		asset.isGIF = (asset.type === 'image' && _.endsWith(asset.url, '.gif'));
		asset.isSVG = (asset.type === 'image' && _.endsWith(asset.url, '.svg'));
		asset.isHDR = (asset.type === 'image' && _.endsWith(asset.url, '.hdr'));

		if (!asset.options.playOnEvents) asset.options.playOnEvents = [];
		if (!asset.options.stopOnEvents) asset.options.stopOnEvents = [];
		if (!asset.options.volume) asset.options.volume = 1;

		asset.hasPlayEvents = asset.options.playOnEvents.length > 0;
		asset.hasStopEvents = asset.options.stopOnEvents.length > 0;
		asset.hasAtlas = asset.options.atlases && asset.options.atlases.length > 0;
		asset.hasCompression = "compression" in asset.options;

		// Поднимаем размер файла (в байтах) из options на верхний уровень - используется для инвалидации кэша сжатия
		// при подмене содержимого ассета с тем же именем файла (см. getAssetCompressionCacheFileName)
		if (asset.options.size) asset.size = asset.options.size;

		if (withCacheKey) asset.cacheKey = this.getAssetCompressionCacheFileName(Creative.getCreative(version['creative_id']), version, asset);

		return asset;

	},

	// Ключ ассета для общего кэша разобранных данных Spine (см. SpinePlayer): getAsset при каждом вызове клонирует options,
	// поэтому по самим данным скелета кэш не работает. Ключ меняется при замене файлов ассета (timestamp, size)
	getSpineCacheKey(asset) {

		if (!asset) return null;

		return `${asset['version_id']}-${asset.codename}-${new Date(asset.timestamp).getTime()}-${asset.size || 0}`;

	},

	getAssetCompressionCacheFileName(creative, version, asset, ext = '') {

		if (!asset) return null;

		let compression = this.getMergedAssetCompression(asset);

		let compression_string = compression;

		// Предусматриваем и очищенный для релиза ассет и не очищенный
		let assetOptions = asset.options || asset;

		if (asset.type === 'atlas') compression_string = `${compression}-${assetOptions.atlasScale || 1}-${assetOptions.atlasShapePadding || 0}-${assetOptions.atlasExtrude || 1}-${assetOptions.atlasTrimMode || 'Trim'}-rotation-${!!assetOptions.atlasRotation}-${assetOptions.atlasFormat || 'png'}-${assetOptions.atlasOpt || 'RGBA8888'}-${assetOptions.atlasDitherType || 'FloydSteinbergAlpha'}-tinypng-${!!assetOptions.atlasTinyPng}-files-${sha1(this.getAtlasImagesKeys(creative, version, asset).join(','))}`;
		else if (asset.type === 'image') compression_string = `${compression}-tinypng-${assetOptions.tinyPng !== false}`;
		else if (asset.type === 'sound') compression_string = `${assetOptions.bitrate || 64}kbps`;
		else if (asset.type === 'video') {
			const crfPart = assetOptions.videoCRF ? `crf-${assetOptions.videoCRF}-` : '';
			compression_string = `video-${assetOptions.jsmpeg ? 'jsmpeg-' : ''}${crfPart}${assetOptions.videoBitrate || 2048}kbps-audio-${assetOptions.audioBitrate || 128}kbps-stereo-${assetOptions.audioStereo !== false}`;
		}

		// Учитываем подмену самой картинки ассета (у dimension вариаций ассета имя файла и url останутся прежними, поэтому добавляем и dimensionCacheKey)
		let image_file_string = (asset.url || assetOptions?.relativeLocalPath || '') + (asset.size || 0) + (assetOptions?.replacedFrom?.dimensionCacheKey || '');

		return `${creative.id}-${compression_string}-${sha1(image_file_string)}${ext ? '.' + ext : ''}`;

	},

	getMergedAssetCompression(asset) {

		// Для изображений находящихся в атласах возвращаем 100% качество
		if (asset.options && asset.options.atlases && asset.options.atlases.length > 0) return 1;

		// Для ассетов которые не сжимаются возвращаем 100% качество
		if (!(['image', 'atlas'].includes(asset.type))) return 1;

		if (asset.options && asset.options.compression) return asset.options.compression;

		// Для тех кто сжимается возвращаем 80% по умолчанию
		return asset.compression || 0.8;

	},

	getAtlasImagesKeys(creative, version, atlasAsset) {

		let keys = [];

		let assets = this.getVersionAssets(version, false);

		_.each(assets, asset => {

			if (asset.type === 'image' && _.includes(asset.options.atlases || [], atlasAsset.codename)) keys.push(this.getAssetCompressionCacheFileName(creative, version, asset, ''));

		});

		keys.sort();

		return keys;

	},

	getVersionAssets(version, withCacheKey = true) {

		if (!version) return {};

		let assetCodenames = _.uniq(_.keys(this.AssetsOriginalByVersionByCodename[version.baseVersionId || version.id]).concat(_.keys(this.AssetsByVersionByCodename[version.id])));

		let assets = {};

		_.each(assetCodenames, assetCodename => {

			assets[assetCodename] = this.getAsset(version, assetCodename, withCacheKey);

		});

		let endCardVersion = Renderer.getEndCardVersion(Creative.getCreative(version['creative_id']), version);

		if (endCardVersion) {

			let endCardAssets = this.getVersionAssets(endCardVersion, withCacheKey);

			_.each(endCardAssets, (asset, assetCodename) => {

				if (assets[assetCodename]) console.warn(`EndCard Asset conflict! Playable already have asset with codename "${assetCodename}"`);

				assets[assetCodename] = asset;

			});

		}

		return assets;

	},

	cleanVersionAssets(versionAssets, creative = Creative.SelectedCreative) {

		let result = {};

		_.each(versionAssets, asset => {

			let mergedAsset = this.cleanVersionAsset(asset, false, creative);

			if (mergedAsset) result[asset.codename] = mergedAsset;

		});

		return result;

	},

	cleanVersionAsset(asset, forThePreview = false, creative = Creative.SelectedCreative) {

		// !!! Похожий код на серверной стороне есть - меняя что-то тут наверняка нужно изменить и на клиенте

		if (!asset) return null;

		// Не добавляем отменённые ассеты
		if (asset.Tags.disabled) return null;

		// ### Не добавляем атласы вообще если указано forThePreview (будут добавляться отдельные картинки)
		// Настройки ассетов влияющие на анимации нужно отправлять во фрейм всё-таки.
		// if (asset.type === 'atlas' && forThePreview) return null;

		// Не добавляем изображения находящиеся в атласах
		if (asset.type === 'image' && !forThePreview && asset.options?.atlases && asset.options.atlases.length > 0) return null;

		let data = {};

		// Для креативов типа playable сохраняем мерж options в корень ассета для обратной совместимости
		if (creative?.type === 'playable') {

			data = _.extend(_.pick(asset, ['publisher_id', 'creative_id', 'version_id', 'codename', 'type', 'url', 'timestamp']), asset.options);

		} else {

			data = _.extend(_.pick(asset, ['publisher_id', 'creative_id', 'version_id', 'codename', 'type', 'url', 'timestamp']), { options: _.cloneDeep(asset.options || {}) });

		}

		// Заменяем урл, чтобы сервер выдавал сжатые ассеты в зависимости от настроек и выдавал атласы изменённые в дашборде
		if (_.includes(['image', 'atlas', 'sound', 'video', 'spine'], asset.type)) data["url"] = this.getAssetActualUrl(asset, {jsmpeg: asset.options?.jsmpeg});

		/*if (asset.type === 'atlas') {

			// Устанавливаем раздельно json и url для загрузки изображения
			data.json = asset.json;
			data.image = this.getAssetActualUrl(asset, {imagesForAtlases: true});
			data.image = data.image.substr(data.image.lastIndexOf('/') + 1);

		}*/

		return data;

	},

	getMergedAssetCodename(asset) {

		let codename = asset.codename;

		// Нужно вернуть название пропаршеному ассету такое какое было в атласе если этот ассет достали из атласа
		if (asset.type === 'image' && asset.options.atlases && asset.options.atlases.length > 0 && codename.indexOf('|') > 0) codename = codename.substr(codename.lastIndexOf('|') + 1);

		return codename;

	},

	// Для случайных ассетов создаём все возможные варианты в Assets
	expandRandomAssets(settings, assets) {

		_.each(assets, (asset, name) => {

			if (this.isRandomAsset(asset)) {

				if (asset["values"]) {

					this.expandRandomSettingsAsset(assets, name, asset, asset["values"]);

				} else if (asset["valueFrom"]) {

					if (asset["valueFrom"] in settings) {

						this.expandRandomAsset(assets, name, asset, settings[asset["valueFrom"]]["values"]);

					} else if (asset["valueFrom"] in assets) {

						this.expandRandomAsset(assets, name, asset, assets[asset["valueFrom"]]["values"]);

					}

				}

				delete assets[name];

			}

		});

		return assets;

	},

	// Для случайного ассета создаём все возможные варианты в Assets
	expandRandomAsset(assets, name, asset, values) {

		for (let i=0; i<values.length; i++) {

			let new_asset = _.cloneDeep(asset);

			// По этим полям определяется что ассет рандомный
			// Так как новый ассет уже не рандомный - нужно их удалить
			// Дальше есть проверка на эти поля и код сработает неверно если не удалить
			delete new_asset["values"];
			delete new_asset["valueFrom"];

			new_asset["url"] = asset["url"].replace("?", values[i]);

			assets[name + '-' + values[i]] = new_asset;

		}

	},

	isRandomAsset(asset) {

		return asset["url"] && asset["url"].indexOf('?') > -1 && asset.type === 'image';

	},

	isChangedAsset(version, assetCodename) {

		return !!(this.AssetsByVersionByCodename[version?.id]?.[assetCodename]);

	},

	downloadAsset(asset) {

		let url = Asset.getAssetActualUrl(asset, {addTimestamp: true, imagesForAtlases: true});

		let xhr = new XMLHttpRequest();
		xhr.open("GET", url, true);

		Auth.authorizeRequest(xhr);

		xhr.responseType = "blob";
		xhr.onload = function(){
			let urlCreator = window.URL || window.webkitURL;
			let imageUrl = urlCreator.createObjectURL(this.response);
			let tag = document.createElement('a');
			tag.href = imageUrl;
			tag.download = asset.codename;
			document.body.appendChild(tag);
			tag.click();
			document.body.removeChild(tag);
		};
		xhr.send();

	},

	requestFile(type, next) {

		let input = document.createElement('input');
		input.type = 'file';
		input.style.position = 'absolute';
		input.style.left = '0';
		input.style.top = '0';
		input.style.transform = 'scale(0.1)';
		input.style.visibility = 'hidden';
		document.body.appendChild(input);

		if (type === 'image') input.accept = "image/png, image/jpeg, image/gif, image/svg+xml";
		else if (type === 'video') input.accept = "video/mp4";
		else if (type === 'sound') input.accept = "audio/mpeg";
		else if (type === 'web-font') input.accept = ".ttf, .otf, .woff, .woff2, .eot, font/ttf, font/otf, font/woff, font/woff2";
		else input.accept = type;

		input.addEventListener('change', e => {

			next(e.target.files[0]);

			document.body.removeChild(input);

		});

		input.addEventListener('blur', e => {

			document.body.removeChild(input);

		});

		input.click();

	},

	// Выбор нескольких файлов (accept - список допустимых расширений / mime типов), next получает массив выбранных файлов
	requestFiles(accept, next) {

		let input = document.createElement('input');
		input.type = 'file';
		input.multiple = true;
		input.accept = accept;
		input.style.position = 'absolute';
		input.style.left = '0';
		input.style.top = '0';
		input.style.transform = 'scale(0.1)';
		input.style.visibility = 'hidden';
		document.body.appendChild(input);

		input.addEventListener('change', e => {

			next(Array.from(e.target.files || []));

			document.body.removeChild(input);

		});

		input.addEventListener('blur', e => {

			document.body.removeChild(input);

		});

		input.click();

	},

	addAsset(assets_config, file) {

		let formData = new FormData();

		formData.append("versionId", Version.SelectedVersion.id);
		formData.append("assetType", assets_config.type);
		formData.append("file", file);

		let url = 'http://' + SetupSettings["domain"] + '/asset/add';
		if (location.protocol === 'https:') url = 'https://' + SetupSettings["domain"] + '/asset/add';

		let xhr = new XMLHttpRequest();

		xhr.open("POST", url);

		Auth.authorizeRequest(xhr);

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				assets_config.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [assets_config]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			assets_config.isUploading = true;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.upload.onloadend = function(e) {

			assets_config.isUploading = false;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.send(formData);

	},

	// Загрузка нового ассета Spine из трёх выбранных файлов (json + atlas + png) - части набора определяются по расширению файла.
	// Возвращает false, если не хватает файлов и загрузка не началась
	addSpineAsset(assets_config, files) {

		let getFile = ext => _.find(files, file => _.toLower(file.name).endsWith('.' + ext));
		let spineFiles = {json: getFile('json'), atlas: getFile('atlas'), png: getFile('png')};
		let missingParts = _.filter(_.keys(spineFiles), part => !spineFiles[part]);

		if (missingParts.length) {

			Notifications.showError(`Spine asset requires .json, .atlas and .png files. Missing: ${_.map(missingParts, part => '.' + part).join(', ')}`);

			return false;

		}

		let formData = new FormData();

		formData.append("versionId", Version.SelectedVersion.id);
		_.each(spineFiles, (file, part) => formData.append(part, file));

		let xhr = new XMLHttpRequest();

		xhr.open("POST", `${location.protocol}//${SetupSettings["domain"]}/asset/add-spine`);

		Auth.authorizeRequest(xhr);

		xhr.onload = function() {

			if (xhr.status !== 200) Notifications.showError('Spine asset upload failed');

		};

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				assets_config.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [assets_config]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			assets_config.isUploading = true;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.upload.onloadend = function(e) {

			assets_config.isUploading = false;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.send(formData);

		return true;

	},

	// Загрузка нового ассета спрайтовой анимации из выбранных файлов. Сервер сам распознаёт вид анимации:
	// последовательность кадров (несколько картинок), спрайт-лист без json (одна картинка) или атлас с json (json + текстура).
	// Возвращает false, если файлы не выбраны и загрузка не началась
	addSpriteAnimationAsset(assets_config, files) {

		files = _.filter(files, file => file && file.name);

		if (!files.length) {

			Notifications.showError('Sprite animation files are not selected');

			return false;

		}

		let formData = new FormData();

		formData.append("versionId", Version.SelectedVersion.id);

		// Набор файлов передаётся полями file-0, file-1, ... (см. Service.getRouterClientData на сервере)
		_.each(files, (file, index) => formData.append('file-' + index, file));

		let xhr = new XMLHttpRequest();

		xhr.open("POST", `${location.protocol}//${SetupSettings["domain"]}/asset/add-sprite-animation`);

		Auth.authorizeRequest(xhr);

		xhr.onload = function() {

			if (xhr.status !== 200) Notifications.showError('Sprite animation asset upload failed');

		};

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				assets_config.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [assets_config]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			assets_config.isUploading = true;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.upload.onloadend = function(e) {

			assets_config.isUploading = false;
			Broadcast.call('Asset Upload Progress', [assets_config]);

		};

		xhr.send(formData);

		return true;

	},

	createAtlas() {

		Server.sendToSocket({
			CreateAtlas: Version.SelectedVersion.id
		});

	},

	getAtlasColor(asset) {

		if (!asset) return null;

		return this.atlasesColors[asset.options.atlasColor - 1];

	},

	replaceAsset(asset, file) {

		let formData = new FormData();

		formData.append("versionId", asset['version_id']);
		formData.append("assetCodename", asset['codename']);
		formData.append("file", file);

		let url = `${location.protocol}//${SetupSettings["domain"]}/asset/replace`;

		let xhr = new XMLHttpRequest();

		xhr.open("POST", url);

		Auth.authorizeRequest(xhr);

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				asset.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [asset]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			asset.isUploading = true;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.upload.onloadend = function(e) {

			asset.isUploading = false;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.send(formData);

	},

	uploadAsset(asset, file) {

		let formData = new FormData();

		formData.append("versionId", asset['version_id']);
		formData.append("assetCodename", asset['codename']);
		formData.append("file", file);

		let url = `${location.protocol}//${SetupSettings["domain"]}/asset/upload`;

		let xhr = new XMLHttpRequest();

		xhr.open("POST", url);

		Auth.authorizeRequest(xhr);

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				asset.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [asset]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			asset.isUploading = true;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.upload.onloadend = function(e) {

			asset.isUploading = false;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.send(formData);

	},

	uploadIntoAtlas(asset, file) {

		let formData = new FormData();

		formData.append("versionId", asset['version_id']);
		formData.append("assetCodename", asset['codename']);
		formData.append("file", file);

		let url = `${location.protocol}//${SetupSettings["domain"]}/asset/uploadIntoAtlas`;

		let xhr = new XMLHttpRequest();

		xhr.open("POST", url);

		Auth.authorizeRequest(xhr);

		xhr.upload.onprogress = function(e) {

			if (e.lengthComputable) {

				asset.uploadProgress = e.loaded / e.total;
				Broadcast.call('Asset Upload Progress', [asset]);

			}

		};

		xhr.upload.onloadstart = function(e) {

			asset.isUploading = true;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.upload.onloadend = function(e) {

			asset.isUploading = false;
			Broadcast.call('Asset Upload Progress', [asset]);

		};

		xhr.send(formData);

	},

	setAssetProperty(asset, property_name, value, delay = 500) {

		Server.sendWithTimeout({
			SetAssetProperty: {
				versionId: asset['version_id'],
				assetCodename: asset.codename,
				propertyName: property_name,
				propertyValue: value
			}
		}, `${asset['version_id']}-${asset.codename}-${property_name}`, delay);

	},

	compressAssets(versionId, assetCodenames) {

		Server.sendToSocket({
			CompressAssets: {
				versionId: versionId,
				assetCodenames: assetCodenames
			}
		});

	},

	getAssetActualUrl(asset, options = {}) {

		if (asset.type === 'image' || asset.type === 'atlas' || asset.type === 'sound' || asset.type === 'video') {

			let url = `${location.protocol}//${SetupSettings["domain"]}/asset/get/${asset['version_id']}/${asset.codename}`;

			if (asset.type === 'image') {

				if (asset.isPNG) url += '.png';
				if (asset.isJPG) url += '.jpg';
				if (asset.isGIF) url += '.gif';
				if (asset.isSVG) url += '.svg';
				if (asset.isHDR) url += '.hdr';

			}

			else if (asset.type === 'video') {

				// 2020.11.08 - .ts in the end is not worked - because Creative Template replaces only .mp4 on .ts and .mp3
				// if (options.jsmpeg) url += '.ts';
				// else url += '.mp4';

				url += '.mp4';

			}

			else if (asset.type === 'atlas') {

				if (options.imagesForAtlases) url += '.' + asset.options.atlasFormat;
				else url += '.json';

			}

			else if (asset.type === 'sound') {

				if (url.indexOf('{ogg,mp3}') >= 0) url = url.replace('{ogg,mp3}', 'mp3');
				else url += '.mp3';

			}

			const params = {};
			if (options.addTimestamp) params.v = asset.timestamp.getTime();
			if (options.preview) params.cache = this.getAssetCompressionCacheFileName(Creative.getCreative(asset["creative_id"]), Version.getVersion(asset["version_id"]), asset);

			// Оригинальный файл ассета: нужен для предпросмотра видео - сжатое jsmpeg-видео хранится как MPEG-TS поток (.ts),
			// который браузер не воспроизводит в теге video (см. getAssetVideoPreviewUrl)
			if (options.original) params.original = 1;

			if (Object.keys(params).length) {
				url += '?' + new URLSearchParams(params).toString();
			}

			return url;

		} else {

			let url = asset["new_url"] || asset.url;

			if (url.indexOf('http') !== 0 && url.indexOf('data:') !== 0) url = Settings.getCurrentVersionAssetsPath() + url;

			url += '?v=' + asset.timestamp.getTime();

			return url;

		}

	},

	// URL видео-ассета для предпросмотра в дашборде: сжатое сервером видео (такое же играет креатив), но для jsmpeg -
	// оригинальный файл, так как сжатый jsmpeg хранится как MPEG-TS поток (.ts), который браузер не воспроизводит в теге video
	getAssetVideoPreviewUrl(asset) {

		if (!asset || !asset.url) return '';

		let url = this.getAssetActualUrl(asset, {addTimestamp: true, preview: true, original: !!asset.options?.jsmpeg});

		// Размер сжатого файла в url: при пересжатии видео (например, после смены CRF) превью загружает файл заново
		let compressedSize = this.selectedVersionAssets[asset.codename]?.compressionData?.size || 0;

		return `${url}&size=${compressedSize}`;

	},

	getAssetOriginalUrl(asset) {

		let baseVersionId = Version.getVersion(asset['version_id'])?.baseVersionId;

		let assetOriginal = this.AssetsOriginalByVersionByCodename[asset['version_id']]?.[asset.codename]
			|| this.AssetsOriginalByVersionByCodename[baseVersionId]?.[asset.codename];

		if (!assetOriginal) return null;

		return new URL(Settings.getCreativeAssetsPath(Creative.getCreative(asset['creative_id']), Version.getVersion(asset['version_id'])) + assetOriginal.url, 'https://example.com').href;

	},

	getSize(assetCodenames) {

		let size = 0;

		_.each(assetCodenames, assetCodename => {

			let compressionData = this.selectedVersionAssets[assetCodename].compressionData;

			let version = Version.SelectedVersion;
			if (!version) return {size: null};

			let asset = this.selectedVersionAssets[assetCodename];

			if (!asset.Tags.disabled) {
				if (compressionData && !compressionData.error && compressionData.size) size += compressionData.size;
			}

		});

		return size;

	},

	getCompressionData(assetCodename) {

		let version = Version.SelectedVersion;
		if (!version) return {size: null};

		let creative = Creative.getCreative(version['creative_id']);
		let asset = this.getAsset(version, assetCodename);

		if (!asset) return null;

		let cacheKey = this.getAssetCompressionCacheFileName(creative, version, asset);

		return this.CompressionCacheData[version['creative_id']][cacheKey];

	},

	getProcessing(assetCodenames) {

		let is_processing = false;

		_.each(assetCodenames, assetCodename => {

			let cacheKey = this.selectedVersionAssets[assetCodename].cacheKey;

			if (Monitoring.activeProcesses['asset-compress'][cacheKey]) is_processing = true;

		});

		return is_processing;

	},

	getCacheKey(assetCodename) {

		let version = Version.SelectedVersion;
		if (!version) return '';

		let creative = Creative.getCreative(version['creative_id']);
		let asset = this.getAsset(version, assetCodename);

		return this.getAssetCompressionCacheFileName(creative, version, asset);

	},

	getUnknown(assetCodenames) {

		let is_unknown = false;

		_.each(assetCodenames, assetCodename => {

			let compressionData = this.selectedVersionAssets[assetCodename].compressionData;

			if (!compressionData) is_unknown = true;

		});

		return is_unknown;

	},

	getError(assetCodenames) {

		let is_error = false;

		_.each(assetCodenames, assetCodename => {

			let compressionData = this.selectedVersionAssets[assetCodename].compressionData;

			if (compressionData && compressionData.error) is_error = compressionData.error;

		});

		return is_error;

	}

});

window.Asset = Asset;

export { Asset }

